import BaseURLConfigStore from './baseUrlConfigStore';
import IdentityManager from '../identity/IdentityManagerFactory';
import EmailStore from './emailStore';
import BrandingStore from './brandingStore';

const initCfg = () => {
  return fetch('/config.json').then((res) => {
    if (res.status !== 200) {
      console.log('Looks like there was a problem. Status Code: ' + res.status);
      return;
    }
    return res.json().then((data) => {
      BaseURLConfigStore.setBaseUrl(data.BASE_URL);
      BaseURLConfigStore.setStartPage(data.startPage || '');
      EmailStore.default_email = data.DEFAULT_EMAIL;
      BrandingStore.logo_login_size = data.branding.logoLoginSize;
      BrandingStore.logo_size = data.branding.logoSize;
      BrandingStore.series_colors = data.branding.SeriesColors;
      BrandingStore.kycUrl = data.kycUrl;
      return IdentityManager.init(data.authz);
    });
  });
};

export default initCfg;
